import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { applyTheme, readTheme } from './shared/lib/theme';
import { i18nReady } from './shared/i18n';
import { registerShell } from './shared/offline/register';
import { reloadForNewVersion } from './shared/lib/staleBuild';
import { prefetchHotScreens, watchIntent } from './app/prefetch';
import './app/global.css';

applyTheme(readTheme());
registerShell();
// Вышла новая версия, а страница старая: подгрузка кода не находит файл — обновляемся сами.
window.addEventListener('vite:preloadError', (e) => {
  if (reloadForNewVersion()) e.preventDefault();
});

const root = document.getElementById('root');
if (root === null) {
  throw new Error('Нет #root в index.html');
}
// Русский интерфейс стартует сразу; английский ждёт свой словарь (отдельный файл), чтобы не мелькал русский текст.
void i18nReady.then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
prefetchHotScreens();
watchIntent();
